var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 20.5,
    height: 14.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_658_23669",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 20.5,
    height: 14.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_658_23669)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 6,
    height: 15,
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15H6V0H0V15Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2676 6.73241C12.0376 6.96235 11.6491 6.75442 11.7129 6.43554L12 5L11 5.5L10.5 4L10 5.5L9 5L9.28711 6.43554C9.35088 6.75442 8.96235 6.96235 8.73241 6.73241C8.60405 6.60405 8.39595 6.60405 8.26759 6.73241L8 7L7 6.5L7.5 7.5L7.2357 7.7643C7.10553 7.89447 7.10553 8.10553 7.2357 8.2357L8.5 9.5H10L10.25 11H10.75L11 9.5H12.5L13.7643 8.2357C13.8945 8.10553 13.8945 7.89447 13.7643 7.7643L13.5 7.5L14 6.5L13 7L12.7324 6.73241C12.6041 6.60405 12.3959 6.60405 12.2676 6.73241Z",
    fill: "#FF3131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flag-icon.9bc579fb49f748bc7a13a6596faea2df.svg";
export { ForwardRef as ReactComponent };